import { Pipe, PipeTransform } from '@angular/core';
import { formatCurrency, getCurrencySymbol, DecimalPipe } from '@angular/common';
import { isNumber } from 'util';

@Pipe({
    name: 'customcurrency',
})

export class CustomCurrencyPipe implements PipeTransform {
    transform(
        value: string,
        currencyCode: string = 'INR',
        display:
            | 'code'
            | 'symbol'
            | 'symbol-narrow'
            | string
            | boolean = 'symbol',
        digitsInfo: string = '',
        locale: string = 'en-US',
    ): string | null {
        const data = (parseFloat(value));
        if (!isNaN(data)) {
            return formatCurrency(
                data,
                locale,
                getCurrencySymbol(currencyCode, 'wide'),
                currencyCode,
                digitsInfo,
            );
        } else {
            return value;
        }
    }
}
